import { Component, OnInit } from '@angular/core';
import { ColumnMode, SelectionType } from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import { AccountService } from '../../../../shared/services/admServices/accounts.service';
import { Advertiser } from '../../../../models/admModel/account.model';

@Component({
  selector: 'adm-adver-component',
  templateUrl: './adver-component.html',
  styleUrls: ['./adver-component.scss'],
})

export class accadvertisersComponent implements OnInit {

  currentRate = 1;
  advertisersData: any;
  currentAdvertiser = new Advertiser();
  currentAdvertiserId: any;
  selected: any[] = [];
  ColumnMode = ColumnMode;
  SelectionType = SelectionType;

  constructor(private toastrService: ToastrService, private accountService: AccountService) {}

  ngOnInit() {
    this.getAdvertisers();
  }

  getAdvertisers(): void {
    this.accountService.getAllAdvertiser()
    .subscribe(
     data => {
       this.advertisersData = data.data;
       this.selected = [this.advertisersData[0]];
       this.currentAdvertiserId = this.advertisersData[0].id;
       this.currentAdvertiser.about =this.advertisersData[0].about;
       this.currentAdvertiser.email = this.advertisersData[0].email;
       this.currentAdvertiser.phone = this.advertisersData[0].phone;
       this.currentAdvertiser.rating = this.advertisersData[0].rating;
     },
     error => {
       console.log(error);
     });
  }

  onUpdate(){
    this.accountService.updateAdvertiser(this.currentAdvertiserId, this.currentAdvertiser)
    .subscribe(
      data => {
        this.toastrService.success('Advertiser data updated.', 'Success !');
        this.getAdvertisers();
      },
      error => {
        console.log(error);
        this.toastrService.error('Update data failed.', 'Error !');
      });
  }

  onSelect({ selected }) {
    this.currentAdvertiserId = selected[0].id;
    this.currentAdvertiser.about = selected[0].about;
    this.currentAdvertiser.email = selected[0].email;
    this.currentAdvertiser.phone = selected[0].phone;
    this.currentAdvertiser.rating = selected[0].rating;
  }

}
